import PlayerStore from "@/store/player";
import CU from "@/utils/c-u";
import VkInsets from "@/utils/vk-insets";
import {IntegrationUtils} from "@/utils/integration-utils";

/**
 * Диагностика жалоб «низ интерфейса за экраном» и «чёрная полоса снизу».
 * Спорят три высоты: визуальный вьюпорт, layout-вьюпорт и то, что реально видит игрок
 * (VK на Android рисует окно под системными панелями). По строке из client_log видно,
 * какая из них верная у конкретного игрока - без этого правки остаются гаданием.
 *
 * Пишем только для VK и не больше пары строк за сессию.
 */
export default class ViewportReport {

    private static readonly MAX_PER_SESSION: number = 3;

    private static sent: number = 0;

    public static log(tag: string): void {
        if (!ViewportReport.watched() || ViewportReport.sent >= ViewportReport.MAX_PER_SESSION) {
            return;
        }
        ViewportReport.sent++;
        try {
            PlayerStore.logClientError('VP ' + tag + ' ' + ViewportReport.compose()).catch(() => {});
        } catch (e) {
            // диагностика не должна ронять игру
        }
    }

    /**
     * VK - жалобы на низ интерфейса (AOF: «не видно героев»), ОК - на правый край
     * (AOF-3099, арена и клан за экраном). Обе оболочки открывают игру в айфрейме,
     * и что там видит игра, кроме как из лога, узнать неоткуда.
     */
    private static watched(): boolean {
        return IntegrationUtils.isVkUser() || IntegrationUtils.isOkUser();
    }

    private static compose(): string {
        const vv = window.visualViewport;
        const canvas = document.getElementsByTagName('canvas').item(0);
        const doc = document.documentElement;

        return [
            'vv=' + Math.round(vv.width) + 'x' + Math.round(vv.height)
                + '@' + Math.round(vv.offsetLeft) + ',' + Math.round(vv.offsetTop) + '/' + vv.scale,
            'frame=' + (window.top !== window.self ? 1 : 0),
            'ref=' + (document.referrer || '-').slice(0, 60),
            'inner=' + window.innerWidth + 'x' + window.innerHeight,
            'client=' + (doc ? doc.clientWidth + 'x' + doc.clientHeight : '-'),
            'screen=' + window.screen.width + 'x' + window.screen.height,
            'dpr=' + window.devicePixelRatio,
            'css=' + CU.CSS_WIDTH + 'x' + CU.CSS_HEIGHT,
            'canv=' + CU.CANVAS_WIDTH + 'x' + CU.CANVAS_HEIGHT,
            'style=' + (canvas ? canvas.style.width + 'x' + canvas.style.height : '-'),
            'insetBottom=' + VkInsets.getBottomCss(vv.height),
            'vk=' + VkInsets.describe(),
        ].join(' | ');
    }
}
